import { render, staticRenderFns } from "./pocketMoneyItem.vue?vue&type=template&id=256a8cec&"
import script from "./pocketMoneyItem.vue?vue&type=script&lang=js&"
export * from "./pocketMoneyItem.vue?vue&type=script&lang=js&"
import style0 from "./pocketMoneyItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports